module.exports = __webpack_public_path__ + "img/loader.be00fc4a.svg";